import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Animation, Button, PageSection, Select } from '@gik/ui';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/homepage/i18n/en';
import { getAssetsUrl } from '@gik/core/utils/LinkUtils';
import ctaDesktop from '../../assets/create-cta/desktop/CTA-desktop.json';
import ctaMobile from '../../assets/create-cta/mobile/CTA-mobile.json';
import { CreateClickedLocation, useCreateAnalyticsController } from '@gik/create/hooks/useCreateAnalytics';
import { navigateTo } from '@/utils/environment';
import { RecipientType } from '@gik/create/enums/RecipientType';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';

const blockName = 'create';

export default function Create() {
  const bem = bemBlock(blockName);

  // TODO remove this and have an endpoint from backend exposing this info
  const createPageOptions = [
    {
      label: i18n.t(translationKeys.createPageMyself),
      value: RecipientType.Myself,
    },
    {
      label: i18n.t(translationKeys.createPageSomeoneElse),
      value: RecipientType.SomeoneElse,
    },
    {
      label: i18n.t(translationKeys.createPageOrganization),
      value: RecipientType.Organization,
    },
  ];

  const [value, setValue] = React.useState(null);
  const { trackCreateClicked } = useCreateAnalyticsController();

  const isMd = useBreakpoint(Breakpoint.MD);

  function handleCreateClicked() {
    trackCreateClicked(CreateClickedLocation.HOMEPAGE_BOTTOM);
    navigateTo(value ? `/create?for=${value}` : '/create');
  }

  return (
    <PageSection className={bem(null)} variant={'aqua'} decoration={'foliage'}>
      <main className={bem('copy')}>
        <h2 className={bem('title')}>{i18n.t(translationKeys.createPageTitle)}</h2>
        <p className={bem('content')}>{i18n.t(translationKeys.createPageContent)}</p>

        <div className={bem('create-container')}>
          <Select
            className={bem('select')}
            placeholder={'Who’s the page for?'}
            options={createPageOptions}
            value={value}
            onChange={setValue}
          />

          <Button className={bem('button')} variant={'secondary'} pill={!isMd} onClick={handleCreateClicked}>
            {i18n.t(translationKeys.getStarted)}
          </Button>
        </div>
      </main>

      <aside className={bem('animation-container')}>
        {isMd ? (
          <Animation
            mode={'looped'}
            data={ctaDesktop}
            assetsPrepend={`${getAssetsUrl()}homepage/create-cta/desktop/images/`}
          />
        ) : (
          <Animation
            mode={'looped'}
            data={ctaMobile}
            assetsPrepend={`${getAssetsUrl()}homepage/create-cta/mobile/images/`}
          />
        )}
      </aside>
    </PageSection>
  );
}
